import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "./Services/authService";
import PopupModal from "./SubComp/PopupModal";

const SEEN_KEY = "seenWelcomePopupVersion";

const WelcomeModal = () => {
  const navigate = useNavigate();
  const [popup, setPopup] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let cancelled = false;

    api
      .get("/user_data_endpoint/deal-alert")
      .then((res) => {
        if (cancelled) return;
        const data = res.data?.dealAlert;
        if (!data?.active) return;

        const seen = localStorage.getItem(SEEN_KEY);
        if (String(data.version) === seen) return;

        setPopup(data);
        // Small delay so it doesn't flash in before the page has settled
        setTimeout(() => {
          if (!cancelled) setVisible(true);
        }, 500);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, []);

  const handleClose = () => {
    setVisible(false);
    if (popup?.version != null) {
      localStorage.setItem(SEEN_KEY, String(popup.version));
    }
  };

  const handleCtaClick = () => {
    const link = popup?.buttonLink?.trim();
    handleClose();
    if (!link) return;
    if (link.startsWith("/")) {
      // Internal route, e.g. /Home
      navigate(link);
    } else {
      // External destination — accept "thatpixel.art" as well as full URLs
      window.location.href = /^https?:\/\//i.test(link) ? link : `https://${link}`;
    }
  };

  if (!visible || !popup) return null;

  return <PopupModal popup={popup} onClose={handleClose} onCtaClick={handleCtaClick} />;
};

export default WelcomeModal;
